import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { CloseIcon } from '@client/components/shared/SvgIcons';
import Dialog from '@client/components/shared/Dialog';
import Logo from '@client/components/shared/Logo';
import ResetPasswordSuccess from '../resetPasswordSuccess/ResetPasswordSuccess';
import DoiSuccess from '../doiSuccess/DoiSuccess';
import { OVERLAYS } from '../../types';
import styles from './SuccessOverlayWrapper.scss';

export const OVERLAY_MAP = {
    [OVERLAYS.OVERLAY_RESET_PASSWORD]: ResetPasswordSuccess,
    [OVERLAYS.OVERLAY_DOI]: DoiSuccess,
};

class SuccessOverlayWrapper extends PureComponent {
    static propTypes = {
        successOverlay: PropTypes.string.isRequired,
        closeOverlay: PropTypes.func.isRequired,
    };

    render() {
        const { successOverlay, closeOverlay } = this.props;
        const SuccessOverlayComp =
            successOverlay && OVERLAY_MAP[successOverlay];

        return (
            <Dialog
                isShown={!!SuccessOverlayComp}
                size={'wide'}
                wrapperNoPadding
                mobileFullScreenDialog={false}
                theme="onboarding"
            >
                <div styleName="close-icon-wrapper" onClick={closeOverlay}>
                    <CloseIcon styleName="close-icon" />
                </div>
                <div styleName="logo">
                    <Logo />
                </div>
                {SuccessOverlayComp && (
                    <SuccessOverlayComp closeOverlay={closeOverlay} />
                )}
            </Dialog>
        );
    }
}

export default CSSModules(SuccessOverlayWrapper, styles, {
    allowMultiple: true,
});
